import { createFileRoute } from '@tanstack/react-router'
import { ApplicantEditor } from './-ApplicantEditor'

// ModuleGuard komt van de recruitment-route.tsx layout — geen wikkel per pagina.
export const Route = createFileRoute('/hr/recruitment/applicants/$id')({
  component: ApplicantDetail,
})

function ApplicantDetail() {
  const { id } = Route.useParams()
  // `key`: bladeren naar een andere sollicitant begint met een schone editor, zodat niets van de
  // vorige (een open venster, een half ingevulde aanbieding) blijft hangen.
  return <ApplicantEditor key={id} id={id} />
}
